import styled from "styled-components";

const StyledLogo = styled.div`
  text-align: center;
`;

const Img = styled.img`
  height: ${(props) => props.size || "3rem"};
  width: auto;
`;

function Logo({ size }) {
  return (
    <StyledLogo>
      <Img src="/images/WiMuleLogo902.svg" alt="Logo" size={size} />
    </StyledLogo>
  );
}

export default Logo;
